import React, { useState } from "react";
import Icon from "../../../../components/Icon";
import Tooltip from "../../../../components/Tooltip";
import ConfirmModal from "../../../../components/ConfirmModal";
import { deleteEntry } from "../../services/KBService";
import { KB_CATEGORIES, getKBCategory } from "./kbConstants";

export function KBCard({ entry, onEdit, onDelete }) {
  const [deleting, setDeleting] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const cat = KB_CATEGORIES[getKBCategory(entry.issue_type)] || KB_CATEGORIES.other;

  async function handleDelete() {
    setDeleting(true);
    try {
      await deleteEntry(entry.id);
      onDelete(entry.id);
    } catch (e) {
      alert(`Delete failed: ${e.message}`);
    } finally {
      setDeleting(false);
      setShowConfirm(false);
    }
  }

  return (
    <>
      <div
        style={{
          background: "#fff",
          border: `1px solid ${cat.border}`,
          borderTop: `3px solid ${cat.color}`,
          borderRadius: 10,
          padding: "14px 16px",
          display: "flex",
          flexDirection: "column",
          gap: 10,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: 8,
          }}
        >
          <div style={{ flex: 1 }}>
            <div
              style={{
                display: "flex",
                gap: 6,
                flexWrap: "wrap",
                marginBottom: 6,
              }}
            >
              <Tooltip text={`Category: ${cat.label}`}>
                <span
                  style={{
                    fontSize: 10,
                    background: cat.bg,
                    color: cat.color,
                    padding: "2px 8px",
                    borderRadius: 10,
                    fontWeight: 700,
                    border: `1px solid ${cat.border}`,
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 3,
                    cursor: "default",
                  }}
                >
                  <Icon name={cat.icon} size={10} color={cat.color} />
                  {entry.issue_type}
                </span>
              </Tooltip>
              {entry.is_global && (
                <Tooltip text="Available to all organizations">
                  <span
                    style={{
                      fontSize: 10,
                      background: "#EFF6FF",
                      color: "#1D4ED8",
                      padding: "2px 8px",
                      borderRadius: 10,
                      fontWeight: 700,
                      border: "1px solid #BFDBFE",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 3,
                      cursor: "default",
                    }}
                  >
                    <Icon name="globe" size={10} color="#1D4ED8" /> Global
                  </span>
                </Tooltip>
              )}
            </div>
            <h3
              style={{
                margin: 0,
                fontSize: 13,
                fontWeight: 700,
                color: "#111827",
                lineHeight: 1.4,
              }}
            >
              {entry.title}
            </h3>
          </div>
          <div style={{ display: "flex", gap: 5, flexShrink: 0 }}>
            <button
              onClick={() => onEdit(entry)}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 4,
                padding: "4px 9px",
                border: "1px solid #E5E7EB",
                borderRadius: 6,
                background: "#fff",
                fontSize: 11,
                cursor: "pointer",
                color: "#374151",
                fontWeight: 500,
              }}
            >
              <Icon name="edit" size={11} color="#6B7280" />
              Edit
            </button>
            <button
              onClick={() => setShowConfirm(true)}
              disabled={deleting}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 4,
                padding: "4px 9px",
                border: "1px solid #FECACA",
                borderRadius: 6,
                background: "#FEF2F2",
                fontSize: 11,
                cursor: deleting ? "not-allowed" : "pointer",
                color: "#DC2626",
                fontWeight: 500,
              }}
            >
              <Icon name="trash" size={11} color="#DC2626" />
              {deleting ? "…" : "Delete"}
            </button>
          </div>
        </div>
        <p style={{ margin: 0, fontSize: 12, color: "#6B7280", lineHeight: 1.6 }}>
          {entry.description}
        </p>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
          <div
            style={{
              background: "#FFFBEB",
              border: "1px solid #FDE68A",
              borderRadius: 7,
              padding: "9px 10px",
            }}
          >
            <div
              style={{
                fontSize: 9,
                fontWeight: 700,
                color: "#B45309",
                textTransform: "uppercase",
                letterSpacing: "0.08em",
                marginBottom: 4,
              }}
            >
              Root cause
            </div>
            <p
              style={{
                margin: 0,
                fontSize: 11,
                color: "#92400E",
                lineHeight: 1.5,
              }}
            >
              {entry.root_cause}
            </p>
          </div>
          <div
            style={{
              background: "#F0FDF4",
              border: "1px solid #BBF7D0",
              borderRadius: 7,
              padding: "9px 10px",
            }}
          >
            <div
              style={{
                fontSize: 9,
                fontWeight: 700,
                color: "#15803D",
                textTransform: "uppercase",
                letterSpacing: "0.08em",
                marginBottom: 4,
              }}
            >
              Resolution
            </div>
            <p
              style={{
                margin: 0,
                fontSize: 11,
                color: "#166534",
                lineHeight: 1.5,
              }}
            >
              {entry.resolution}
            </p>
          </div>
        </div>
      </div>

      {showConfirm && (
        <ConfirmModal
          title="Delete Knowledge Base Entry"
          message={`Are you sure you want to delete "${entry.title}"? This action cannot be undone.`}
          confirmLabel="Delete Entry"
          variant="danger"
          loading={deleting}
          onConfirm={handleDelete}
          onCancel={() => setShowConfirm(false)}
        />
      )}
    </>
  );
}

export default KBCard;
